import React, { FunctionComponent, useState } from 'react';

import { useModalToggle } from '../../hooks/useModalToggle';
import { LazyLoader } from '../LazyLoader/LazyLoader';
import { ImageGrid, ImageGridProps } from './ImageGrid';
import { Image } from './imageGridTypes';

const Lightbox = React.lazy(() => import('../Lightbox/Lightbox'));

const toLightbox = ({ url }: Image) => ({
  thumbnail: url ?? '',
  original: url ?? '',
});

export const ImageGridWithLightbox: FunctionComponent<ImageGridProps> = ({
  images,
  ...props
}) => {
  const { setOpen, isOpen, ref, Portal } = useModalToggle();
  const [selectedImage, setSelectedImage] = useState<Image | null>(null);
  const [imagesWithErrors, setImagesWithErrors] = useState<Image[]>([]);

  const onLightboxClose = () => {
    setOpen(false);
    setSelectedImage(images[0]);
  };

  const onImageSelect = (image: Image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const errorIds = imagesWithErrors.map(x => x.id);
  const validImages = images.filter(x => !errorIds.includes(x.id));

  if (!validImages.length) {
    return null;
  }

  return (
    <>
      <ImageGrid
        {...props}
        images={validImages}
        onImageSelect={onImageSelect}
        onImageError={image =>
          setImagesWithErrors(images => images.concat([image]))
        }
      />
      {isOpen && (
        <Portal scrollLock focusLock background>
          <LazyLoader>
            <Lightbox
              ref={ref}
              selectedImageIndex={
                selectedImage ? validImages.indexOf(selectedImage) : 0
              }
              onClose={onLightboxClose}
              images={validImages.map(toLightbox)}
            />
          </LazyLoader>
        </Portal>
      )}
    </>
  );
};
